import { Injectable } from '@angular/core';
import { DynamicComponent, DynamicPageElement } from '../dynamic-pages/dynamic-pages.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DynamicPageEditorHelperService {

  draggedElement: DynamicComponent | null = null;

  editElementInGrid: DynamicPageElement | null = null;

  productIdsChanged = new Subject<DynamicPageElement>();

  public copy: DynamicPageElement | null = null;

  private _selectedElement: DynamicPageElement | null = null;

  currentView: 'desktop' | 'tablet' | 'mobile' = 'desktop';

  indexSelectedOnPage: number | null = null;

  setSelectedElement(el: DynamicPageElement | null) {
    this._selectedElement = el;
  }

  getSelectedElement() {
    return this._selectedElement;
  }

  
}
